var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "#F9DEDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 30c0-4.852.98-7.858 2.81-9.69 1.832-1.83 4.838-2.81 9.69-2.81h8.5V24c0 3.083.495 5.616 2.19 7.31 1.694 1.695 4.227 2.19 7.31 2.19h6.5V42c0 4.852-.98 7.858-2.81 9.69-1.832 1.83-4.838 2.81-9.69 2.81H30c-4.852 0-7.858-.98-9.69-2.81-1.83-1.832-2.81-4.838-2.81-9.69V30Zm39.998 1.931a1.496 1.496 0 0 0-.444-.998L41.067 14.946A1.496 1.496 0 0 0 40 14.5H30c-5.148 0-9.142 1.02-11.81 3.69-2.67 2.668-3.69 6.662-3.69 11.81v12c0 5.148 1.02 9.142 3.69 11.81 2.668 2.67 6.662 3.69 11.81 3.69h12c5.148 0 9.142-1.02 11.81-3.69 2.67-2.668 3.69-6.662 3.69-11.81v-9.988c0-.027 0-.054-.002-.08ZM41.5 24v-4.379L52.379 30.5H48c-2.917 0-4.384-.506-5.19-1.31-.805-.806-1.31-2.273-1.31-5.19Zm-17 14a1.5 1.5 0 0 1 1.5-1.5h12a1.5 1.5 0 0 1 0 3H26a1.5 1.5 0 0 1-1.5-1.5Zm1.5 6.5a1.5 1.5 0 0 0 0 3h8a1.5 1.5 0 0 0 0-3h-8Z",
    fill: "#410E0B"
  })));
};
export default SvgFile;